interface Set<T> {
    componentId: string;
    data: T;
}

declare global {
    interface Window {
        __BPD_APP__: any[];
    }
}

function getComponentData<T>(element: HTMLElement): T | null {
    const id: string | undefined = element.dataset.componentId;

    if (!id) return null;

    const { data }: { data: T } = window.__BPD_APP__.find((set: Set<T>) => set.componentId === id);

    return data;
}

export default getComponentData;
